import React from "react";
import ReactDOM from "react-dom";

import { GlobalContext } from "../../../../utils/globalprovider.js";
import { directDownloadJson } from "../../../../utils/download.js";
import ZTrack from "./tracks/trackz.js";
import TranscriptTrack from "./tracks/transcripttrack.js";
import NewTranscriptTrack from "./tracks/newtranscripttrack.js";
import CPTrack from "./tracks/trackcp.js";
import EmptyTrack from "./tracks/trackempty.js";
import TCTrack from "./tracks/tracktc.js";
import STTrack from "./tracks/trackst.js";
import SequencesTrack from "./tracks/sequencestrack.js";

import {V2_GetOneFrameDuration,  V2_TimecodeGetTimeCodeFormatString, V2_GetSecondTimeCodeStart,V2_ConvertSecondToTimeCodeString,V2_ConvertSecondToTimeCodeStringFromAsset,V2_ConvertSecondToTimeCodeStringMs,V2_RoundedTimeCode } from "../../../../utils/timecodev2.js";

import poubImg from "./assets/poub.png"
import toupImg from "./assets/toup.png"
import todownImg from "./assets/todown.png"

import minimiserImg from "./assets/minimiser.png"
import agrandirImg from "./assets/agrandir.png"



import {fromTimeToPixel} from "../../../../utils/timelineutils.js"

import TimeLineAudio from "./assets/tracks/timelineaudio.png"
import TimeLineCorTrans from "./assets/tracks/timelinecortrans.png"
import TimeLineOriTrans from "./assets/tracks/timelineoritrans.png"
import TimeLineCP from "./assets/tracks/timelinecp.png"
import TimeLineST from "./assets/tracks/timelinest.png"
import TimeLineSequences from "./assets/tracks/timelinesequences.png"


import "./timeline.css";
import { apiCreateProjects } from "../../../../utils/apis.js";
import { onRedrawAfterRedoOrUndo } from "../transcript/actions/undo-redo.js";



class TimeLine extends React.Component
{
    static contextType = GlobalContext;
    constructor(props)
    {
        super(props);
        var style = getComputedStyle(document.body);
        this.backcolor = style.getPropertyValue('--timeline-backcolor');
        this.cursorcolor = style.getPropertyValue('--timeline-cursor-color');
        this.leftwidth = parseInt(style.getPropertyValue(('--timeline-left-width')));

        this.state = {
            bottomHeight : parseInt(style.getPropertyValue('--timeline-bottom-height')),
            currentTime: 0,
            maxduration: 3 * 60,



            contextMenuSequence: {
                visible: false,
                menuX:0,
                menuY:0,
            }
        };


        this.canvasglobalRef = React.createRef(); // canvas dessin des pistes
        this.canvasleftRef = React.createRef(); // canvas de gauche
        
        
        this.trackList =[];

        this.onresize = this.onresize.bind(this);
        this.redraw = this.redraw.bind(this);
        this.timelineheight = -1;
        this.timelinewidth = -1; // hauteur de la timeline sans la barre inférieure
        
        this.currentTime=0;

        this.oldTimeCode ="";
        this.oldxpos=-1;
        this.recreate=true;
        this.tempCanvas = document.createElement("canvas");
        this.starttime = 0;
        this.duration = 9; // 5 secondes d'affichage par défaut
        this.handleWheel = this.handleWheel.bind(this);
        this.plus = this.plus.bind(this);
        this.moins = this.moins.bind(this);


        this.enddraw = true;
        this.drawFile = true;

        this.contextMenuSequenceRef = React.createRef()


        // déplacement souris
        this.handleMouseEnter = this.handleMouseEnter.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.handleMouseUp = this.handleMouseUp.bind(this);
        this.handleMouseDbClick = this.handleMouseDbClick.bind(this);
        this.documentHandleMouseUp = this.documentHandleMouseUp.bind(this);


        this.handleMouseEnterButtons = this.handleMouseEnterButtons.bind(this);
        this.handleMouseMoveButtons = this.handleMouseMoveButtons.bind(this);
        this.handleMouseLeaveButtons = this.handleMouseLeaveButtons.bind(this);
        this.handleMouseDownButtons = this.handleMouseDownButtons.bind(this);
        this.handleMouseUpButtons = this.handleMouseUpButtons.bind(this);



        this.moveInProgress = false;


        // creation des images boutons
        this.imgpoub = document.createElement("img");
        this.imgpoub.src = poubImg;
        this.imgtoup = document.createElement("img");
        this.imgtoup.src = toupImg;
        this.imgtodown = document.createElement("img");
        this.imgtodown.src = todownImg;
     
        this.imgmininiser = document.createElement("img");
        this.imgmininiser.src = minimiserImg;

        this.imgagrandir = document.createElement("img");
        this.imgagrandir.src = agrandirImg;

        // creation des images de type
        this.imgTimeLineAudio = document.createElement("img");
        this.imgTimeLineAudio.src = TimeLineAudio;

        this.imgTimeLineCP = new Image();
        this.imgTimeLineCP.src = TimeLineCP;

        this.imgTimeLineSequences = new Image();
        this.imgTimeLineSequences.src = TimeLineSequences;

        this.imgTimeLineOriTrans = new Image();
        this.imgTimeLineOriTrans.src = TimeLineOriTrans;

        this.imgTimeLineCorTrans = new Image();
        this.imgTimeLineCorTrans.src = TimeLineCorTrans;

        this.imgTimeLineST = new Image();
        this.imgTimeLineST.src = TimeLineST;
        


        // memorisation des changements de plan
        //this.listcp = null;
        this.paramsst = null;
        this.downloadCPDone = this.downloadCPDone.bind(this);


        // gestion des times codes
        


    }

    
    handleClickSequence = () => {
        this.setState({
            contextMenuSequence: {
                visible: false,
                menuX: 0,
                menuX: 0
            }
        });
    };

    handleMenuActionSequence = (action) => {
        if (this.props.doActionSequence) 
            this.props.doActionSequence(action, 
                this.state.contextMenuSequence.sequence, 
                this.state.contextMenuSequence.sequenceId, 
                this.state.contextMenuSequence.time,
                this.state.contextMenuSequence.currenttime,
                this.state.contextMenuSequence.cpbefore,
                this.state.contextMenuSequence.cpafter,
                this.state.maxduration + this.offsetTime(),
            )
        this.handleClickSequence();
    };    

  offsetTime()
  {
    var secstart = 0;
    if (this.props.timecodeAsset)
    {
        if ("viid" in this.props.timecodeAsset)
            secstart = V2_GetSecondTimeCodeStart(this.props.timecodeAsset.vitimecode,this.props.timecodeAsset.vinum,this.props.timecodeAsset.viden);
        else
            secstart = V2_GetSecondTimeCodeStart(this.props.timecodeAsset.astimecode,this.props.timecodeAsset.asnum,this.props.timecodeAsset.asden);
    }
    return secstart;
  }

  getCurrentNumDen()
  {
    if ("viid" in this.props.timecodeAsset)
        return {num: this.props.timecodeAsset.vinum, den: this.props.timecodeAsset.viden};
    else
        return {num: this.props.timecodeAsset.asnum, den: this.props.timecodeAsset.asden};

    
  }
  getTimeCodeStringNoOffset(timecode)
  {
    if (this.props.timecodeAsset)
        return V2_ConvertSecondToTimeCodeStringFromAsset(timecode ,this.props.timecodeAsset,this.props.playerparams.displaytcms);
   else
    {
       if (this.props.playerparams.displaytcms)
          return V2_ConvertSecondToTimeCodeStringMs(timecode);
        else
          return V2_ConvertSecondToTimeCodeString(timecode);
    }

  }

  getTimeCodeString(timecode)
  {
    
    if (this.props.timecodeAsset)
    {
        
        var secstart = 0;
        if ("viid" in this.props.timecodeAsset)
            secstart = V2_GetSecondTimeCodeStart(this.props.timecodeAsset.vitimecode,this.props.timecodeAsset.vinum,this.props.timecodeAsset.viden);
        else
            secstart = V2_GetSecondTimeCodeStart(this.props.timecodeAsset.astimecode,this.props.timecodeAsset.asnum,this.props.timecodeAsset.asden);
        return V2_ConvertSecondToTimeCodeStringFromAsset(timecode + secstart,this.props.timecodeAsset,this.props.playerparams.displaytcms);
    }

    else
    {

        
        if (this.props.playerparams.displaytcms)
          return V2_ConvertSecondToTimeCodeStringMs(timecode);
        else
          return V2_ConvertSecondToTimeCodeString(timecode);
    }
  }


    handleMouseEnterButtons(event)
    {

    } 
    handleMouseMoveButtons(event)
    {

    

        const box = document.getElementById('timelinebuttons');
        const rect = box.getBoundingClientRect();


        var currentH = 0;
        if ((this.canvasglobalRef) && (this.canvasglobalRef.current))
            currentH = this.canvasglobalRef.current.height;
        const posx = event.clientX - rect.left;
        var posy = event.clientY - rect.top;

        // on corrige posY
        posy = (currentH / (rect.bottom-rect.top)) * posy;
        
        

        this.trackList.forEach ((cl) => {
            cl.getButton(posx,posy, true);
        
         
        })
        this.drawFile = true;
    




    } 
    handleMouseLeaveButtons(event)
    {
        this.trackList.forEach ((cl) => {
            cl.selectedbutton="";
        
         
        })
        this.drawFile = true;

    }


    deleteAssetByType(type)
    {

        for (var t = 1; t < this.trackList.length ; t++)
        {
            
            if (this.trackList[t].type === type)
            {
                this.trackList.splice (t, 1);
                for (var t1 = 1; t1 < this.trackList.length ; t1++)
                    this.trackList[t1].baseline = this.trackList[t1-1].baseline + this.trackList[t1-1].height;
        
                
                return;
            }
        }

    }

    handleMouseDbClick(event)
    {

        const box = document.getElementById('timelinedata');
        const rect = box.getBoundingClientRect();
        // conversion en time....
        const posx = event.clientX - rect.left;
        const posy = event.clientY - rect.top;
        var time  = (this.duration * posx) / (rect.right - rect.left);
        time = time + this.starttime;

        if (this.props.type === "subtitling")
        {
            var sttrack =this.getSTTrack(posy);
            if (sttrack)
            {
                const ret = sttrack.getMouseDbClick(time, event.shiftKey, event.ctrlKey, event.altKey);
            }
        }
    }

    handleMouseDownButtons(event)
    {
        const box = document.getElementById('timelinebuttons');
        const rect = box.getBoundingClientRect();

        var currentH = 0;
        if ((this.canvasglobalRef) && (this.canvasglobalRef.current))
            currentH = this.canvasglobalRef.current.height;
        const posx = event.clientX - rect.left;
        var posy = event.clientY - rect.top;

        // on corrige posY
        posy = (currentH / (rect.bottom-rect.top)) * posy;

        for (var t = 1; t < this.trackList.length ; t++)
        {
            var cl = this.trackList[t];
            var ret = cl.getButton(posx,posy, false);
            if (ret != "")
            {

                this.trackList.forEach ((cl) => {
                    cl.selectedbutton="";
                })
        
                

                switch (ret)
                {
                    case "minagr":
                        // cl est la piste en cours
                        cl.minimised = !cl.minimised;
                        this.onresize(this.size.width, this.size.height);

                        break;
                    case "poub":
                    
                        
                        this.trackList.splice (t, 1);
                        for (var t1 = 1; t1 < this.trackList.length ; t1++)
                            this.trackList[t1].baseline = this.trackList[t1-1].baseline + this.trackList[t1-1].height;
                        
                        this.onresize(this.size.width, this.size.height);
                        break;
                    case "toup":

                        [this.trackList[t], this.trackList[t-1]] = [this.trackList[t-1], this.trackList[t]];
                        for (var t1 = 1; t1 < this.trackList.length ; t1++)
                            this.trackList[t1].baseline = this.trackList[t1-1].baseline + this.trackList[t1-1].height;
                        this.recreate = true;
                        this.drawFile = true;
                        break;

                    case "todown":
                        
                        [this.trackList[t], this.trackList[t+1]] = [this.trackList[t+1], this.trackList[t]];
                        for (var t1 = 1; t1 < this.trackList.length ; t1++)
                            this.trackList[t1].baseline = this.trackList[t1-1].baseline + this.trackList[t1-1].height;
                        this.recreate = true;
                        this.drawFile = true;
                        break;

                    
                }

                break;
            }
        
         
        }
        this.drawFile = true;
    

    } 

    minimiseTrack (trackname)
    {

        for (var cl of this.trackList)
        {
            
            if  (cl.type===trackname)
            {
                cl.minimised = true;
                this.onresize(this.size.width, this.size.height);
                
            }
        }
        

    }

    handleMouseUpButtons(event)
    {

    }
 
    getTimeLineHeight()
    {
        this.timelineheight=0;
        this.trackList.forEach ((cl) => {
                this.timelineheight += cl.getHeight();
             
            }
        )
        
        return this.timelineheight;
    }

    getTimeLineFullHeight()
    {
        return this.getTimeLineHeight();
    }

    createDefaultTimeLine()
    {
        if (this.trackList.length == 0)
        {
            var cl = new TCTrack("tc",null,"00:00:00.000","",0,0, this);
            cl.baseline = 0;
            this.trackList.push (cl);
            var cl = new EmptyTrack("empty",null,"","",0,0, this);
            cl.baseline = this.trackList[0].getHeight();
            this.trackList.push (cl);
            var cl = new EmptyTrack("empty",null,"","",0,0, this);
            cl.baseline = this.trackList[0].baseline + this.trackList[1].getHeight();
            this.trackList.push (cl);


        }
        return this.getTimeLineFullHeight();
        

    }

    setNewTimeLineSize (sizeInPixel)
    {

         this.timelineheight = sizeInPixel;
        // on recherche la taille des tracks fixed

        var fixedHeight = 0;
        var variableHeight = 0;
        this.trackList.forEach ((cl) => 
            {

                if (cl.minimisable)
                {
                    if (cl.minimised)
                        fixedHeight += cl.minimisedHeight;
                    else
                    {
                        if (cl.isFixedHeight())
                            fixedHeight += cl.getDefaultHeight();
                        else
                            variableHeight += cl.getDefaultHeight();

                    }
                }
                else
                {
                    if (cl.isFixedHeight())
                        fixedHeight += cl.getDefaultHeight();
                    else
                        variableHeight += cl.getDefaultHeight();
                }

            }
        )
        
        const resteVariable = sizeInPixel - fixedHeight;
        var coef = resteVariable;
        if (variableHeight !==0) coef = coef/variableHeight;

        
    
        var yStart = 0;
        var yfinal = 0;
        this.trackList.forEach ((cl) => 
            {

                if ((cl.minimisable) && (cl.minimised))
                {
                        cl.setPositions (yStart, cl.minimisedHeight);
                        yStart += cl.minimisedHeight;
                        yfinal += cl.minimisedHeight;


                }
                else
                {
                    if (cl.isFixedHeight())
                    {
                        cl.setPositions (yStart, cl.getDefaultHeight());
                        yStart += cl.getDefaultHeight();
                    }
                    else
                    {



                        // on calcul la nouvelle hauteur
                        var lastHeight = cl.getDefaultHeight();
                        lastHeight = lastHeight * coef;
                        
                        
                        //if (lastHeight < cl.minHeight) lastHeight = cl.minHeight;
                        //if (lastHeight > cl.maxHeight)  lastHeight = cl.maxHeight;
                        
                        cl.setPositions(yStart, lastHeight);
                        yStart += lastHeight;

                    }
                    yfinal += cl.getHeight();
                }
                
            }
        )
        this.canvasglobalRef.current.height = this.timelineheight;
        this.tempCanvas.height = this.timelineheight

        this.handleDocumentMouseDown = this.handleDocumentMouseDown.bind(this)
      
        this.recreate = true;

        return this.getTimeLineFullHeight();

    }

    handleDocumentMouseDown = (e) => {

    if (
        this.contextMenuSequenceRef.current &&
        this.contextMenuSequenceRef.current.contains(e.target)
    ) {
        return;
    }

    if (this.state.contextMenuSequence?.visible) {
        this.setState({
            contextMenuSequence: {
                visible: false,
                menuX: 0,
                menuY: 0
            }
        });
    }
    };
    componentWillUnmount()
    {
        
        
        document.removeEventListener("mousedown", this.handleDocumentMouseDown, true);
    }

    componentDidMount()
    {
        const div = document.querySelector('#timelinediv'); // Sélectionne la div

        // Crée un ResizeObserver
        const resizeObserver = new ResizeObserver(entries => {
          for (let entry of entries) {
            const { width, height } = entry.contentRect;
            this.onresize(width, height);
            this.size = {width:width, height: height};
            
          }
        });
        
        // Observer les changements de taille de la div time line
        // $$$ ICI
        resizeObserver.observe(div);
     
        const scrolldiv = document.getElementById("timelinediv");
        scrolldiv.addEventListener("wheel", this.handleWheel);
   
        const timelinedata = document.getElementById("timelinedata");
        timelinedata.addEventListener("mouseenter", this.handleMouseEnter);
        timelinedata.addEventListener("mousemove", this.handleMouseMove);
        timelinedata.addEventListener("mouseleave", this.handleMouseLeave);
        timelinedata.addEventListener("mousedown", this.handleMouseDown);
        timelinedata.addEventListener("mouseup", this.handleMouseUp);
        timelinedata.addEventListener("dblclick", this.handleMouseDbClick);


        const timelinebuttons = document.getElementById("timelinebuttons");
        timelinebuttons.addEventListener("mouseenter", this.handleMouseEnterButtons);
        timelinebuttons.addEventListener("mousemove", this.handleMouseMoveButtons);
        timelinebuttons.addEventListener("mouseleave", this.handleMouseLeaveButtons);
        timelinebuttons.addEventListener("mousedown", this.handleMouseDownButtons);
        timelinebuttons.addEventListener("mouseup", this.handleMouseUpButtons);
     
        document.addEventListener("mousedown", this.handleDocumentMouseDown, true);

        this.recreate = true;
        this.enddraw = false;
        setTimeout(()=>
            {requestAnimationFrame(this.redraw);},500);
    }

   
    getCPList()
    {

        const cp = this.getCPTrack();
        if (cp)
            return cp.getCPList();
        return [];

    }


    getCPListToSave()
    {
        const cp = this.getCPTrack();
        if (!cp) return null;
        return cp.listCPToSave;
    }

    getCPListToSaveFileInfos()
    {
        const cp = this.getCPTrack();
        if (!cp) return null;
        return {
            filename: cp.file1,
            id: cp.videoinfos.viid,
            datas: cp.videoinfos,
        };
    }
    clearCPListToSave()
    {
        const cp = this.getCPTrack();
        if (!cp) return null;
        cp.listCPToSave = null;

    }


    componentWillUnmount()
    {

        this.enddraw=true;
        const scrolldiv = document.getElementById("timelinediv");
        scrolldiv.removeEventListener("wheel", this.handleWheel);

        const timelinedata = document.getElementById("timelinedata");
        timelinedata.removeEventListener("mouseenter", this.handleMouseEnter);
        timelinedata.removeEventListener("mousemove", this.handleMouseMove);
        timelinedata.removeEventListener("mouseleave", this.handleMouseLeave);
        timelinedata.removeEventListener("mousedown", this.handleMouseDown);
        timelinedata.removeEventListener("mouseup", this.handleMouseUp);
        timelinedata.removeEventListener("dblclick", this.handleMouseDbClick);
        

        const timelinebuttons = document.getElementById("timelinebuttons");
        timelinebuttons.removeEventListener("mouseenter", this.handleMouseEnterButtons);
        timelinebuttons.removeEventListener("mousemove", this.handleMouseMoveButtons);
        timelinebuttons.removeEventListener("mouseleave", this.handleMouseLeaveButtons);
        timelinebuttons.removeEventListener("mousedown", this.handleMouseDownButtons);
        timelinebuttons.removeEventListener("mouseup", this.handleMouseUpButtons);

    }

    handleWheel (event) 
        {
        
          
          event.preventDefault();

          if (event.ctrlKey)
          {
            if (event.deltaY >0) this.plus();
            if (event.deltaY <0) this.moins();
            return;

          }

          if (event.deltaY >0)
            this.props.playaddtime(0.040 );
          else
          this.props.playaddtime(-0.040 );
        }
           

    

    onresize(newwidth, newheight)
    {

        

        if ((this.canvasglobalRef) && (this.canvasglobalRef.current))
        {
            this.timelinewidth = newwidth;
            this.timelineheight = newheight;
            
            this.canvasglobalRef.current.height = newheight;
            this.canvasglobalRef.current.width = newwidth;


            this.tempCanvas.width = newwidth;
            this.tempCanvas.height = newheight;


            this.setNewTimeLineSize (newheight);

            


            this.drawFile = true;
            this.recreate = true;
        }
            
    }

    forceRecreate()
    {
        this.recreate = true;
    }

    setCurrentTime(time,forceRedraw = false)
    {
      
        

        time = time - this.offsetTime(); 
        if (time < 0) time = 0;
        
        this.recreate = forceRedraw;
        this.drawFile = forceRedraw;
        this.currentTime = time;
        this.setState( {currentTime : time});

        
        
    }

    setCurrentTimeFromPlayer(time,forceRedraw = false)
    {
      
        

        
        this.recreate = forceRedraw;
        this.drawFile = forceRedraw;
        this.currentTime = time;
        this.setState( {currentTime : time});
        
    }


    getEmptyTrack()
    {
        for (var i=0; i < this.trackList.length; i++)
            {
                if (this.trackList[i].getType() === "empty")
                    return i;
            }
        return -1;
    

    }

    setNewId(index,id)
    {
        this.trackList[index].setNewId(id);
        this.drawFile = true;

    }

    setNewDatas(index, datas, id, extendeddatas)
    {
        if (this.trackList[index].id !== id) this.drawFile = true;
        this.trackList[index].setNewDatas(datas, id, extendeddatas);
        
        this.recreate= true;
        this.drawFile = true;
    }

    setNewCPList(cplist)
    {
        for (var i=0; i < this.trackList.length; i++)
        {
                if (this.trackList[i].getType() === "mp4zcp")
                {
                    this.recreate=true;
                    this.drawFile=true;
                    this.trackList[i].setNewJsonCPList(cplist);
                    break;
                }
        }

    }

    setCurrentSubtitle (subtitlennumber)
    {
        for (var i=0; i < this.trackList.length; i++)
        {
                if (this.trackList[i].getType() === "st")
                {
                    this.recreate=true;
                    this.drawFile=true;
                    this.trackList[i].currentSubtitle = subtitlennumber;
                    break;
                }
        }
    }

    setNewSubtitlesByType(datas, id, type,force=false)
    {


        for (var i=0; i < this.trackList.length; i++)
        {
                
                if (this.trackList[i].getType() === type)
                {
                    if ((this.trackList[i].id !== id) || force) this.drawFile = true;
                    this.setNewDatas(i,datas, id);
                
                    break;
                }
            }
        


    }



    setNewSubtitles(datas, id=0)
    {


        for (var i=0; i < this.trackList.length; i++)
        {
                if (this.trackList[i].getType() === "st")
                {
                    if (this.trackList[i].id !== id) this.drawFile = true;
                    this.setNewDatas(i,datas, id);
                    
                    break;
                }
            }
        


    }

    getIndexByType(type)
    {
        for (var i=0; i < this.trackList.length; i++)
            {
                if (this.trackList[i].getType() == type)
                {
        
                    return i;
                }
            }        
        return -1;
    }

    getIndexByTypeAndChannel(type,channel)
    {
        for (var i=0; i < this.trackList.length; i++)
            {
                if ((this.trackList[i].getType() == type) && (this.trackList[i].getChannel() == channel) )
                {
        
                    return i;
                }
            }        
        return -1;
    }

    addTrack(type, datas, file1, file2, channel, id)
    {

 

        for (var i=0; i < this.trackList.length; i++)
        {
            
            if ((this.trackList[i].getId() == id) &&
                (this.trackList[i].getType() == type)
            )
            {
                
                if ( this.trackList[i].getType() !== "mp4zaudio")
                    return;

                if (this.trackList[i].getChannel() === channel)
                    return;
            }
                
        }
  


      switch (type)
      {
        case "st":
            var cl = new STTrack(type,datas, file1, file2,channel ,id, this)

            this.positionneTrack(cl);
            break;

        case "oldst":
            var cl = new STTrack(type,datas, file1, file2,channel ,id, this)
            this.positionneTrack(cl);
            break;
    
        case "sequences":
            // datas = Json Datas, file1 = Asset, 
            var cl = new SequencesTrack(type,datas,file1,"",0,id, this);
            this.positionneTrack(cl);
            break;

        case "trjson":
            var cl = new TranscriptTrack(type,datas, file1, file2, channel ,id, this)
            this.positionneTrack(cl);
            break;

        case "newtrjson":
            var cl = new NewTranscriptTrack(type,datas, file1, file2, channel ,id, this)
            this.positionneTrack(cl);
            break;

        case "mp4zaudio":
            
            var cl = new ZTrack(type,datas, file1, file2, channel ,id, this)
            this.positionneTrack(cl);
            break;
        case "mp4zcp":
            
            
            directDownloadJson (file1, this.downloadCPDone, id.toString());
            cl = new CPTrack(type, datas, file1, file2, channel,id, this)
            this.positionneTrack(cl);
            break;
      }


        for (var i=0; i < this.trackList.length; i++)
        {
            if (i== 0)
                this.trackList[i].baseline = 0;
            else
            {
                this.trackList[i].baseline = this.trackList[i-1].baseline + this.trackList[i-1].height;
            }
        }

        
        if ((this.size.width >0 ) && (this.size.height > 0))
            this.onresize(this.size.width, this.size.height);

        
      
      this.drawFile = true;
      

    }
    getCpListFromTrack ()
    {
        return this.listcp;
    }

    getParamsSTFromTrack()
    {
        return this.paramsst;
    }

    setParamsST(params)
    {
        this.paramsst = params;
    }

    setNewST(newST)
    {
        for (var t=0; t < this.trackList.length; t++)
        {
            var cl = this.trackList[t];
            switch (cl.type)
            {
                case "st":
                    cl.setNewST(newST);
                    this.recreate = true;        
                    break;
            }
        }
                
    }

    downloadCPDone(blob, infos, file)
    {
        this.listcp = blob.list;
    }


    

    positionneTrack (cl)
    {
        var emptyTrack = this.getEmptyTrack();
        if (emptyTrack != -1)
        {
            this.trackList.splice (emptyTrack, 1);
        }



        
        var ontop = cl.ontop;
        var onbottom = cl.onbottom;
        var topmot = cl.ontopmost;
        var bottommost = cl.onbottommost;

        var found= -1;
        if (ontop)
        {
            
            for (var i=0; i < this.trackList.length;i++)
            {
                var xcl = this.trackList[i];
                if ((xcl.onbottom) || (xcl.onbottommost))
                {
                    // on doit insérer avant ça
                    found = i;
                    break;
                } 

                if ((!xcl.ontop) && (!xcl.onbottommost))
                {
                    // on doit insérer apres ça
                    found = i+1;
                    break;
                } 
    
            }    
        }
        else
        {
            if ((onbottom) || (bottommost))
                found=-1;
            else
            {
                for (var i=0; i < this.trackList.length;i++)
                    {
                        var xcl = this.trackList[i];
                        if ((xcl.onbottom) || (xcl.onbottommost))
                        {
                            // on doit insérer avant ça
                            found = i;
                            break;
                        } 
        
            
                    }                    
            }

        }
        if ((found == -1) || (found >= this.trackList.length))
            this.trackList.push(cl);
        else
            this.trackList.splice (found,0, cl);

        this.drawFile = true;
        return;
    }

    redraw()
    {


        var height = this.getTimeLineHeight();
        

        //if ((!this.canvasglobalRef) || (!this.canvasglobalRef.current)) return;
        //if (this.canvasglobalRef.current.height <= 0) return;

        var sTimeCode = this.getTimeCodeString(this.currentTime);
        
        if (this.drawFile)
        {
            if ((this.canvasleftRef) && (this.canvasleftRef.current))
                {
                    this.canvasleftRef.current.width = this.leftwidth;
                    this.canvasleftRef.current.height = this.canvasglobalRef.current.height;
                    const leftcontext = this.canvasleftRef.current.getContext('2d');

                    for (var t=0; t < this.trackList.length; t++)
                    {
                        var cl = this.trackList[t];

                        if (t==0)
                            cl.nobuttons = true;
                        else
                        {
                            cl.toptrack=false;
                            cl.bottomtrack=false;
                            if (t==1)
                                cl.toptrack=true;
                            if (t== this.trackList.length-1)
                                cl.bottomtrack=true;
                        }

                        var img = this.imgTimeLineCorTrans;
                        switch (cl.type)
                        {
                            case "st":
                                img = this.imgTimeLineST;
                                break;
                    
                            case "trjson":
                                img = this.imgTimeLineOriTrans;
                                break;
                    
                            case "newtrjson":
                                img = this.imgTimeLineCorTrans;
                                break;
                    
                            case "mp4zaudio":
                                img = this.imgTimeLineAudio;
                                break;
                            case "mp4zcp":
                                img = this.imgTimeLineCP;
                                break;
                            case "sequences":
                                img = this.imgTimeLineSequences;
                                break;
                    
                        }

                
                        cl.drawTitle (leftcontext, img, sTimeCode, this.leftwidth, this.imgpoub, this.imgtoup, this.imgtodown, this.imgmininiser, this.imgagrandir);


                        

                    }
                }


                         
        }
        this.drawFile = false; //


        if (this.recreate) this.oldxpos = -1; 
        var xpos = fromTimeToPixel(this.currentTime, this.timelinewidth, this.starttime, this.duration);
        if (xpos != this.oldxpos)
        {
            if (this.trackList.length !=0)
            {
                try
                {
                    const leftcontext = this.canvasleftRef.current.getContext('2d');
                    this.trackList[0].drawTitle(leftcontext,null, sTimeCode,this.leftwidth);
                }
                catch(e)
                {
                    this.enddraw = true;
                    return;
                }
            }



            // on repositionne au milieu
            this.starttime = this.currentTime - this.duration/2;
            
            xpos = fromTimeToPixel(this.currentTime, this.timelinewidth, this.starttime, this.duration);
            this.recreate=true;

            //xpos = this.oldxpos+1;
            this.oldxpos = xpos;
            if ((this.canvasglobalRef) && (this.canvasglobalRef.current))
            {


                const tempcontext = this.tempCanvas.getContext('2d');
                
                if (this.recreate)
                {
                    // backfround level 0
                    tempcontext.clearRect(0, 0, this.canvasglobalRef.current.width, this.canvasglobalRef.current.height);    
                    this.trackList.forEach ((cl) => 
                        {
                            cl.redrawbackgroundLevel0(tempcontext,this.timelinewidth);
    
                        }
                    )     


                    var yStart = 0;
                    if (this.trackList.length>0)
                        yStart = this.trackList[0].getHeight();
                    // backfround level 1
                    this.trackList.forEach ((cl) => 
                        {
                            cl.redrawbackgroundLevel1(tempcontext,this.timelinewidth, this.currentTime, sTimeCode, this.starttime, this.duration, height, yStart);
    
                        }
                    )     

                    // foreground
                    this.trackList.forEach ((cl) => 
                        {
                            cl.redrawForeGround(tempcontext,this.timelinewidth, this.currentTime, sTimeCode, this.starttime, this.duration, height);
    
                        }
                    )     


                    this.recreate = false;
                }



                // dessin du curseur
                const context = this.canvasglobalRef.current.getContext('2d');
                
                
                context.clearRect(0, 0, this.canvasglobalRef.current.width, this.canvasglobalRef.current.height);

                try{
                    context.drawImage(this.tempCanvas, 0, 0);
                }catch (e){
                    this.enddraw = true;
                    return;
                }
                context.strokeStyle = this.cursorcolor;
                context.lineWidth = 2;
                context.beginPath();
                context.moveTo(xpos, 0);
                context.lineTo(xpos, height);
                context.stroke();

                context.fillStyle = this.cursorcolor;
                context.beginPath(); // Commence un nouveau chemin
                context.moveTo(xpos-6, 0); // Déplace le point de départ au sommet supérieur
                context.lineTo(xpos+6, 0); // Dessine la ligne vers le sommet inférieur gauche
                context.lineTo(xpos, 12); // Dessine la ligne vers le sommet inférieur droit
                context.closePath(); // Ferme le chemin pour créer un triangle
                
                // Remplir le triangle avec une couleur

                context.fill(); // Remplit le triangle avec la couleur spécifiée
                
            }
            
        }
        if (!this.enddraw) requestAnimationFrame(this.redraw);
       

    }

    handleChangeTimeCode (datas)
    {
        // datas
        //      id : n° sous titre
        //    action: action
        //          tcin: change tcin valeur = value1        
        //          tcout: change tcout valeur = value2
        //          tcst: change tcin et out valeur = value1 et value2


        
        if (this.props.onChangeTimeCode) this.props.onChangeTimeCode(datas);



    }


    setCurrentDuration(duration)
    {
        this.setState( {maxduration : duration});
    }

    decaleTime(value)
    {
        var currenttime = this.state.currentTime;
        currenttime = currenttime + value;
        this.setState( {currentTime : currenttime});
        this.currentTime = currenttime;
        this.recreate = true;
        
    }

    recaleAll()
    {
        const newtc = this.currentTime + this.offsetTime();
        
        this.props.gototime(newtc);

    }
    

    handleMouseEnter()
    {
      

    }


    ondetectionButton(action, time)
    {
        if (this.props.ondetectionButton)
        {
            this.props.ondetectionButton({button: action, value:time});
        }
    }

    getWaveFormTrack(posy)
    {
        for (var cl of this.trackList)
        {
            if  (posy >= (cl.baseline) &&  (posy<=cl.baseline+ cl.height) && (cl.type==="mp4zaudio"))
            {
                return cl;
            }
        }
        return null;

    }

    getCPTrack(posy = null)
    {
        
        if (posy == null)
        {
            for (var cl of this.trackList)
            {
                
                if  (cl.type==="mp4zcp")
                    return cl;
            }
            return null;
        }
        for (var cl of this.trackList)
        {
            if  (posy >= (cl.baseline) &&  (posy<=cl.baseline+ cl.height) && (cl.type==="mp4zcp"))
            {
                return cl;
            }
        }
        return null;
    }

    getSequenceTrack(posy = null)
    {
        if (posy == null)
        {
            for (var cl of this.trackList)
            {
                if  (cl.type==="sequences")
                    return cl;
            }
            return null;
        }
        for (var cl of this.trackList)
        {
            if  (posy >= (cl.baseline) &&  (posy<=cl.baseline+ cl.height) && (cl.type==="sequences"))
            {
                
                return cl;
            }
        }
        return null;

    }


    getSTTrack(posy = null)
    {
        if (posy == null)
        {
            for (var cl of this.trackList)
            {
                if  (cl.type==="st")
                    return cl;
            }
            return null;
        }
        for (var cl of this.trackList)
        {
            if  (posy >= (cl.baseline) &&  (posy<=cl.baseline+ cl.height) && (cl.type==="st"))
            {
                
                return cl;
            }
        }
        return null;

    }

    handleMouseMove(event)
    {
        const box = document.getElementById('timelinedata');
        const rect = box.getBoundingClientRect();
        // conversion en time....
        const posx = event.clientX - rect.left;
        const posy = event.clientY - rect.top;
        var time  = (this.duration * posx) / (rect.right - rect.left);
        time = time + this.starttime;
        // on verifie si on doit faire quelque chose au niveau du curseur

        if (!this.moveInProgress)
        {

        }
        else
        {
            
            const imgpixel = 8;
            var deca = posx - this.moveInProgressLastPosition;
            if (Math.abs(deca) < imgpixel)
            {
                
                //if (this.timerMoveInProgress) clearInterval (this.timerMoveInProgress);
                //this.timerMoveInProgress = null;
                return;
            }

            var decadepart = posx - this.moveInProgressStartPosX;


            
            // est-ce qu'on a changé de sens
            var sens = 1; // avance
            if (posx < this.moveInProgressLastPosition) sens = -1;

            if (this.moveInProgressSens != 0)
            {
                if (this.moveInProgressSens != sens)
                {
                    
                    this.moveInProgressStartPosX = this.moveInProgressLastPosition;

                    this.moveInProgressSens = sens;
                }
            }

            this.moveInProgressSens = sens;
            this.moveInProgressLastPosition = posx;
            const numden = this.getCurrentNumDen();
            var oneframe = V2_GetOneFrameDuration(numden.num,numden.den);

            this.decalageMoveInProgress = (Math.abs(decadepart) / imgpixel) * oneframe * sens;
            if (this.timerMoveInProgress) clearInterval (this.timerMoveInProgress);
            this.timerMoveInProgress = null;
            this.timerMoveInProgress = setInterval( () => {
                if (this.decalageMoveInProgress != 0)
                {
                    const numden = this.getCurrentNumDen();
                    time = V2_RoundedTimeCode(time,numden.num,numden.den);
                    time = time + this.decalageMoveInProgress; if (time <0) time=0;
                    this.props.gototime(time + this.offsetTime());
                    return;
                     

                }

            }, 100);
            

            

            return;


            this.timerMoveInProgress = null;
            this.moveInProgressStartPosX  = posx;
            this.moveInProgressLastPosition = posx;
            this.moveInProgressSens = 1;


            this.decalageMoveInProgress =0;
            this.timerMoveInProgress = null;
            this.moveStartPosX  = posx;

            //const numden = this.getCurrentNumDen();
            time = V2_RoundedTimeCode(time,numden.num,numden.den);
            var ct = V2_RoundedTimeCode(this.LastcurrentTime,numden.num,numden.den); 
            var inter = Math.abs(time - ct);
            var oneframe = V2_GetOneFrameDuration(numden.num,numden.den);

            this.LastcurrentTime = time;
            if (time > ct ) 
                this.decalageMoveInProgress = oneframe
            else
                this.decalageMoveInProgress = - oneframe;



            if (this.timerMoveInProgress) clearInterval (this.timerMoveInProgress);
            this.timerMoveInProgress = null;
            
            if (inter<oneframe) return;
            time = time + this.decalageMoveInProgress; if (time < 0) time=0;

            this.props.gototime(time + this.offsetTime());

            
            this.timerMoveInProgress = setInterval( () => {
                if (this.decalageMoveInProgress != 0)
                {
                    const numden = this.getCurrentNumDen();
                    time = V2_RoundedTimeCode(time,numden.num,numden.den);
                    time = time + this.decalageMoveInProgress; if (time <0) time=0;
                    this.props.gototime(time + this.offsetTime());
                    return;
                     

                }

            }, 1000 / (inter/oneframe) );
            


            return;
        }


        if (this.props.type === "subtitling")
        {



            var sttrack =this.getSTTrack();
            if ( (sttrack) && (sttrack.datasMove != null))
            {

                if (posx < 0) {sttrack.getMouseUp(); return;}
                if (posx >= (rect.right - rect.left) * 0.99 )
                    {sttrack.getMouseUp();  return;}


                const ret = sttrack.moveSubtitle(time,event.shiftKey); // un déplacement est en cours
                if (ret)
                {
                    
                    this.handleChangeTimeCode(ret);
                    this.recreate = true;
                    
                }
                return;
            }
            
            sttrack =this.getSTTrack(posy);
            if (sttrack)
            {
                
                const ret = sttrack.getCursor(time);
                if (ret)
                {
                    box.style.cursor = ret.cursor;
                    return;
                }
            }
        }

        box.style.cursor = 'default';
        // test si on est sur un chagement de plan
        var cptrack =this.getCPTrack(posy);
        if (cptrack )
        {
            
            const ret = cptrack.checkCP(time,posy); // un déplacement est en cours
            if (ret)
            {
                box.style.cursor = "pointer";
            }
        }

        
        if ((time >=this.currentTime - 0.020) && (time <=this.currentTime + 0.020))
            box.style.cursor = 'ew-resize';
        
            

    }
    handleMouseLeave()
    {
        
        var sttrack =this.getSTTrack();
        if (sttrack)
        {
            if (sttrack.datasMove != null)
            {
                sttrack.getMouseUp();
                this.recaleAll();
                return;
            }
        }


        this.moveInProgress=false;

        const box = document.getElementById('timelinedata');
        box.style.cursor = 'default';
    }

    documentHandleMouseUp(event)
    {
        document.removeEventListener ("mouseup", this.documentHandleMouseUp)
        this.handleMouseUp();
    }


    handleMouseDown(event)
    {
        event.preventDefault();
        event.stopPropagation();
        if (this.state.contextMenuSequence.visible)
        {
                this.setState(
                        {
                        contextMenuSequence: {
                            visible: false,
                            menuX: 0,
                            menuY: 0,
                        }
                    }
                )
                return;
        }


        document.addEventListener ("mouseup", this.documentHandleMouseUp)


        const box = document.getElementById('timelinedata');
        const rect = box.getBoundingClientRect();
        // conversion en time....
        const posx = event.clientX - rect.left;
        const posy = event.clientY - rect.top;
        var time  = (this.duration * posx) / (rect.right - rect.left);
        time = time + this.starttime;

        const realTime = time + this.offsetTime();


        console.log("click on time line time = ", time, realTime )

        if ((this.props.type === "transcription") && event.ctrlKey && !event.shiftKey)
        {
            // on regarde si on est sur la wave form
            var wavetrack =this.getWaveFormTrack(posy);
            if (wavetrack)
            {
                if (this.props.onClickOnWaveForm)
                {
                    this.props.onClickOnWaveForm(time, event.altKey)
                    return;
                }
            }

        }

        if (this.props.type === "subtitling")
        {
            var sttrack =this.getSTTrack(posy);
            if (sttrack)
            {
                const ret = sttrack.getMouseDown(time, event.shiftKey, event.ctrlKey, event.altKey);
                
                
                if (ret) 
                {
                    if (this.props.onClickOnSubtitle)
                        this.props.onClickOnSubtitle(ret);
                    return;
                }
            }
        }


        var sequencetrack = this.getSequenceTrack(posy)
        if (sequencetrack)
        {
            const sequence = sequencetrack.getMouseDown(realTime)
            if (sequence.sequenceId !== -1) {
                event.preventDefault();
                if (event.button === 0)
                {
                    if (this.props.onClickOnSequence)
                        this.props.onClickOnSequence(sequence);
                    return;
                }

                const canvas = event.currentTarget;
                const rect = canvas.getBoundingClientRect();

                const x = event.clientX - rect.left;
                const y = event.clientY - rect.top;                

                var ret = false;
                if (this.props.onClickOnSequence)
                    ret = this.props.onClickOnSequence(sequence,false);

                if (ret)
                {
                    event.preventDefault();
                    event.stopPropagation();
                    const numden = this.getCurrentNumDen();

                    // on cherche les changements de plan
                    const tcin = sequence.sequence.in;
                    const tcout = sequence.sequence.out;
                    var shotTcIn = -1;
                    var shotTcOut = -1;

                    const cplist = this.getCPList();
                    const firstTimeCode = this.offsetTime();


                    for (var i=0; i<cplist.length; i++)
                    {
                        const cp = cplist[i];
                        if (
                            ((cp.time + firstTimeCode) < tcin) &&
                            !cp.off
                        )
                            shotTcIn = cp.time + firstTimeCode;

                        if (
                            ((cp.time + firstTimeCode) > tcout) &&
                            !cp.off &&
                            (shotTcOut === -1)
                        )
                            shotTcOut = cp.time + firstTimeCode;


                    }


                    this.setState(
                            {
                            contextMenuSequence: {
                                visible: true,
                                menuX: event.clientX,
                                menuY: event.clientY,
                                disableInsert: !sequencetrack.canCreateSequence(sequence.sequenceId, V2_RoundedTimeCode(realTime,numden.num,numden.den)),
                                
                                disableDeleteWithNext: !sequencetrack.canDeleteWithNext(sequence.sequenceId),
                                disableDeleteWithPrevious: !sequencetrack.canDeleteWithPrevious(sequence.sequenceId),
                                
                                disableSetTcIn: !sequencetrack.canSetTcIn(sequence.sequenceId,V2_RoundedTimeCode(this.currentTime + this.offsetTime(),numden.num,numden.den)),
                                disableSetTcout: !sequencetrack.canSetTcOut(sequence.sequenceId,V2_RoundedTimeCode(this.currentTime + this.offsetTime(),numden.num,numden.den)),

                                
                                disableSetTcInShot: !sequencetrack.canSetTcIn(sequence.sequenceId,V2_RoundedTimeCode(shotTcIn,numden.num,numden.den)),
                                disableSetTcOutShot: !sequencetrack.canSetTcOut(sequence.sequenceId,V2_RoundedTimeCode(shotTcOut,numden.num,numden.den)),
                                
                                disableExtend: !sequencetrack.canExtend(sequence.sequenceId,this.offsetTime()+this.state.maxduration),

                                time: V2_RoundedTimeCode(realTime,numden.num,numden.den),
                                currenttime: V2_RoundedTimeCode(this.currentTime + this.offsetTime(),numden.num,numden.den),
                                sequenceId: sequence.sequenceId,
                                sequence: sequence,
                                cpbefore: shotTcIn,
                                cpafter: shotTcOut,
                            }
                    });
                }


            }            
            return;
        }

        if (event.shiftKey)
        {
            var cptrack =this.getCPTrack(posy);
            if (cptrack )
            {
                
                const ret = cptrack.checkCP(time,posy); // un déplacement est en cours
                if (ret)
                {
                    cptrack.setNewOffValue (ret);
                    if (this.props.forceRecompute) this.props.forceRecompute();
                    this.recreate=true;
                    return;
                }
            }
        }


        if ((time >=this.currentTime - 0.020) && (time <=this.currentTime + 0.020))
        {
            this.moveInProgress = true;


            this.timerMoveInProgress = null;
            this.moveInProgressStartPosX  = posx;
            this.moveInProgressLastPosition = posx;
            this.moveInProgressSens = 0;

        }
        else
            this.props.gototime(time + this.offsetTime());
        
    }
    handleMouseUp()
    {

        var sttrack =this.getSTTrack();
        if (sttrack)
        {
            if (sttrack.datasMove)
                sttrack.getMouseUp()
                
        }
        if ((this.moveInProgress) || (this.timerMoveInProgress))
        {
            this.moveInProgress = false;
            if (this.timerMoveInProgress) clearInterval (this.timerMoveInProgress);
            this.timerMoveInProgress = null;
        }

    } 

    setZoom(value)
    {
        this.duration = value;
        this.recreate = true;
    }

    moins()
    {
        if (this.duration >2)
            {
                this.duration--;
                this.recreate= true;
                if (this.props.onChangeZoomValue) this.props.onChangeZoomValue(this.duration);
    
            }
    
    }
    plus()
    {
        if (this.duration < 30)
        {
            this.duration++;
            this.recreate= true;
            if (this.props.onChangeZoomValue) this.props.onChangeZoomValue(this.duration);

        }

    }

    render()
    {

        return (
            <div className="timeline-global-div" >
                <div className="timeline-timeline-div" id="timelinediv">
                    <div className = "timeline-left-div">
                        <canvas 
                        onContextMenu={(e) => e.preventDefault()}
                        className="timeline-canvas-left-layer" ref={this.canvasleftRef} id="timelinebuttons"
                        />
                    </div>
                    <div className = "timeline-right-div" >

                    {this.state.contextMenuSequence.visible && ReactDOM.createPortal(
                    
                    <div
                        className="context-menu-sequence"
                        onContextMenu={(e) => e.preventDefault()}
                        ref = {this.contextMenuSequenceRef}
                        style={{

                        left: `${this.state.contextMenuSequence.menuX}px`,
                        top: `${this.state.contextMenuSequence.menuY}px`,                            
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="context-menu-item-sequence-title">
                            {this.context.language=="fr"?"Séquence n°":"Sequence #"}
                            {this.state.contextMenuSequence.sequenceId+1}
                        </div>
                        <div
                            className={this.state.contextMenuSequence.disableInsert?"context-menu-item-sequence-disable":"context-menu-item-sequence"}
                            onClick={() => this.handleMenuActionSequence("INSERT")}
                        >
                            {this.context.language=="fr"?"Insérer une séquence":"Insert new sequence"}
                        </div>

                        <div
                            className={this.state.contextMenuSequence.disableDeleteWithNext?"context-menu-item-sequence-disable":"context-menu-item-sequence"}
                            onClick={() => this.handleMenuActionSequence("DELETEWITHNEXT")}
                        >
                            {this.context.language=="fr"?"Supprimer et avancer la séquence suivante":"Delete and advance to the next sequence"}
                        </div>

                        <div
                            className={this.state.contextMenuSequence.disableDeleteWithPrevious?"context-menu-item-sequence-disable":"context-menu-item-sequence"}
                            onClick={() => this.handleMenuActionSequence("DELETEWITHPREVIOUS")}
                        >
                            {this.context.language=="fr"?"Supprimer et prolonger la séquence précédente":"Delete and extend the previous sequence"}
                        </div>

                        <div
                            className={this.state.contextMenuSequence.disableSetTcInShot?"context-menu-item-sequence-disable":"context-menu-item-sequence"}
                            onClick={() => this.handleMenuActionSequence("SETTCINSHOT")}
                        >
                            {this.context.language=="fr"?"Caler le début au changement de plan":"Align the start with the shot change."}
                        </div>

                        <div
                            className={this.state.contextMenuSequence.disableSetTcOutShot?"context-menu-item-sequence-disable":"context-menu-item-sequence"}
                            onClick={() => this.handleMenuActionSequence("SETTCOUTSHOT")}
                        >
                            {this.context.language=="fr"?"Caler la fin au changement de plan":"Align the end with the shot change."}
                        </div>

                        <div
                            className={this.state.contextMenuSequence.disableSetTcIn?"context-menu-item-sequence-disable":"context-menu-item-sequence"}
                            onClick={() => this.handleMenuActionSequence("SETTCIN")}
                        >
                            {this.context.language=="fr"?"Définir le début de la séquence":"Set sequence start time"}
                        </div>

                        <div
                            className={this.state.contextMenuSequence.disableSetTcout?"context-menu-item-sequence-disable":"context-menu-item-sequence"}
                            onClick={() => this.handleMenuActionSequence("SETTCOUT")}
                        >
                            {this.context.language=="fr"?"Définir la fin de la séquence":"Set sequence end time"}
                        </div>

                        <div
                            className={this.state.contextMenuSequence.disableExtend?"context-menu-item-sequence-disable":"context-menu-item-sequence"}
                            onClick={() => this.handleMenuActionSequence("EXTEND")}
                        >
                            {this.context.language=="fr"?"Caler la fin de la séquence à la vidéo":"Set sequence end time to video"}
                        </div>

                    </div>,
                    document.body
                    )}
            


                        <canvas 
                            onContextMenu={(e) => e.preventDefault()}
                            className="timeline-canvas-right-layer" 
                            ref={this.canvasglobalRef} 
                            id="timelinedata"
                        />
                    </div>
                    <div className = "timeline-right-right-div" 
                        onContextMenu={(e) => e.preventDefault()}
                    >
                        <span>
                         {V2_TimecodeGetTimeCodeFormatString(this.props.timecodeAsset.vinum, this.props.timecodeAsset.viden)}
                        </span>
                    </div>
                </div>


                
            </div>
        )

    }

}
TimeLine.defaultProps =
{
    playerparams: {dontscale: true, displaytc:true, displaytcms: false},
}

export default TimeLine;